import { FC } from 'react'
import { EventApi } from '@fullcalendar/core'

import { ServiceOrderTypes } from 'services/serviceOrderV2'
import { formatter, getServiceOrderStatus } from './utils'
import { schedulePeriods } from 'services'
import { RichTooltip } from './components'
import { Popover } from 'components'

import styles from './styles.module.scss'
import joinClassNames from 'utilities/joinClassNames'

const typeLabel: Record<ServiceOrderTypes, string> = {
  INSTALL: 'Instalação',
  MAINTENANCE: 'Manutenção',
  REMOTE_MAINTENANCE: 'M. remota',
  UNINSTALL: 'Desinstalação',
}

type EventCardProps = {
  event: EventApi
}

const EventCard: FC<EventCardProps> = ({ event }) => {
  const { status, number, schedulePeriod, customer, accountCode, type } =
    event.extendedProps

  const startDate = formatter.format(event.start?.getTime())
  const endDate = formatter.format(event.end?.getTime())

  const openStatus = status === 'OPEN'

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <div className={styles.container}>
          <article
            className={joinClassNames(
              styles[status],
              openStatus && styles.open,
              !schedulePeriod && styles.time,
              event.start?.getTime() < new Date().getTime() && styles.past,
            )}
          >
            <header>
              <span>{getServiceOrderStatus(status)}</span>
              {type && <span className={styles.osType}>{typeLabel[type]}</span>}
              {number && <span className={styles.osNumber}>{number}</span>}
            </header>
            <section>
              <h2>{`${accountCode} - ${customer}`}</h2>
              {schedulePeriod ? (
                <p>{schedulePeriods[schedulePeriod]}</p>
              ) : (
                <p>
                  {startDate}-{endDate}
                </p>
              )}
            </section>
          </article>
        </div>
      </Popover.Trigger>
      <Popover.Content>
        <RichTooltip serviceOrderId={event.id} />
      </Popover.Content>
    </Popover.Root>
  )
}

export default EventCard
